import React from "react";
import {
  RaketaUIProvider,
  TextInput,
  ButtonSettings,
  SelectMenu,
} from "@raketa-cms/raketa-cms";
import { MediaManagerContext } from "@raketa-cms/raketa-image-picker";
import MediaManager from "components/cms/MediaManager";
import MarkdownInput from "../../../cms/Forms/MarkdownInput";
import ImagesInput from "../common/ImagesInput";
import FeaturesInput from "./FeaturesInput";
import LicensesInput from "./LicensesInput";
import InputSection from "../common/InputSection";
import ComparisonLinksInput from "./ComparisonLinksInput";

const mediaManager = new MediaManager("/");

const PricingCardSettings = ({ value, name, comparison_data }) => {
  const [settings, setSettings] = React.useState(value);

  const onChange = (key, value) => {
    setSettings((current) => {
      return { ...current, [key]: value };
    });
  };

  return (
    <RaketaUIProvider>
      <MediaManagerContext.Provider value={mediaManager}>
        <div className="field-pannel form-group">
          <TextInput
            type="text"
            label="Title"
            value={settings.title}
            onChange={(val) => onChange("title", val)}
          />

          <MarkdownInput
            label="Description"
            value={settings.description}
            onChange={(val) => onChange("description", val)}
          />

          <TextInput
            type="text"
            label="Hidden logos count"
            value={settings.hidden_logos_count}
            onChange={(val) => onChange("hidden_logos_count", val)}
          />

          <ImagesInput
            label="Logos"
            value={settings.logos || []}
            onChange={(val) => onChange("logos", val)}
          />

          <ImagesInput
            label="Disabled logos"
            value={settings.disabled_logos || []}
            onChange={(val) => onChange("disabled_logos", val)}
          />

          <FeaturesInput
            value={settings.features || {}}
            onChange={(val) => onChange("features", val)}
          />

          <InputSection title="Button 1">
            <ButtonSettings
              label="Button 1"
              value={settings.button_1 || {}}
              onChange={(val) => onChange("button_1", val)}
              hint="This button adds the product to the cart!"
            />
          </InputSection>

          <InputSection title="Button 2">
            <ButtonSettings
              label="Button 2"
              value={settings.button_2 || {}}
              onChange={(val) => onChange("button_2", val)}
            />
          </InputSection>

          <SelectMenu
            label="Execute special action on button 2 click"
            options={[
              ["yes", "Yes"],
              ["no", "No"],
            ]}
            value={settings.button_2_on_click}
            onChange={(val) => onChange("button_2_on_click", val)}
          />

          <TextInput
            type="text"
            label="Glow color (border & text)"
            value={settings.glow_border_color}
            onChange={(val) => onChange("glow_border_color", val)}
          />

          <TextInput
            type="text"
            label="Glow color (outline)"
            value={settings.glow_outline_color}
            onChange={(val) => onChange("glow_outline_color", val)}
          />

          <TextInput
            type="text"
            label="Glowing text"
            value={settings.glowing_text}
            onChange={(val) => onChange("glowing_text", val)}
          />

          <SelectMenu
            label="Action on missing rate plan ID"
            options={[
              ["hide", "Hide"],
              ["disable", "Disable"],
            ]}
            value={settings.on_missing_rate_plan_id}
            onChange={(val) => onChange("on_missing_rate_plan_id", val)}
          />

          <ComparisonLinksInput
            comparisonData={comparison_data}
            value={settings.comparison_links || {}}
            onChange={(val) => onChange("comparison_links", val)}
          />

          <LicensesInput
            value={settings.licenses || []}
            onChange={(val) => onChange("licenses", val)}
          />
        </div>

        <input
          type="hidden"
          name={name}
          defaultValue={JSON.stringify(settings)}
        />
      </MediaManagerContext.Provider>

      {/* <pre>{JSON.stringify(settings, null, 2)}</pre> */}
    </RaketaUIProvider>
  );
};

export default PricingCardSettings;
